<template>

    <div>

        <TopMessage :message="showTopMessage" :colour="showTopMessageColour" />

        <Tabbed uriRoot="account" :names="tabSettings">
            <template #Home>
                <Home @subscriptionInfo="subscriptionInfo" />
            </template>
            <template #Subscriptions>
                <Subscriptions @subscriptionInfo="subscriptionInfo" />
            </template>
            <template #Invoices>
                <Invoices @subscriptionInfo="subscriptionInfo" />
            </template>
            <template #PaymentMethods>
                <PaymentMethods @subscriptionInfo="subscriptionInfo" />
            </template>
            <template #GoogleAccounts v-if="!isShared">
                <GoogleAccounts />
            </template>
        </Tabbed>

    </div>

</template>

<script>
import { mapMutations, mapState } from 'vuex'
import Tabbed from './Tabbed.vue'
import Home from './Account/Home.vue'
import Subscriptions from './Account/Subscriptions.vue'
import Invoices from './Account/Invoices.vue'
import PaymentMethods from './Account/PaymentMethods.vue'
import GoogleAccounts from './Account/GoogleAccounts.vue'
import TopMessage from './../components/Display/TopMessage.vue'
export default {
    name: 'Account',
    components: { Tabbed, Home, Subscriptions, Invoices, PaymentMethods, TopMessage, GoogleAccounts },
    data() {
        return {
            showTopMessage: '',
            showTopMessageColour: 'red'
        }
    },
    computed: {
        ...mapState('general',['userInfo']),
		isShared() {

			return !!this.userInfo.isShared;

		},
        tabSettings () {
            let tabs = {
                Home:{ 
                    title: 'Profile' 
                }, 
                Subscriptions:{ 
                    title: '', 
                    description: '' 
                }, 
                Invoices:{ 
                    title: 'Invoices/Receipts',
                    tab: 'Invoices/Receipts',
                    permalink: 'invoices'
                },
                PaymentMethods: {
                    title: 'Payment Methods',
                    tab: 'Payment Methods',
                    permalink: 'payment-methods'
                }, 
                GoogleAccounts: { 
                    title: 'Google Accounts', 
                    permalink: 'google', 
                    tab: 'Google Accounts' 
                }
            };
            if ( this.isShared ) {
                delete tabs.GoogleAccounts;
            }
            return tabs;
        }
    },
    methods: {
        ...mapMutations('general',['updateVar','printGlobalMessage']),
        subscriptionInfo (info) {
            this.printGlobalMessage(info);
        }
    }
}
</script>